/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createProblemDetailsFromDiscriminatorValue, serializeRevokeContractSigningCommand, type ProblemDetails, type RevokeContractSigningCommand } from '../../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /contracts/{contract-id}/signing/revoke
 */
export interface RevokeRequestBuilder extends BaseRequestBuilder<RevokeRequestBuilder> {
    /**
     * RevokeContractSigning
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @throws {ProblemDetails} error when the service returns a 400 status code
     * @throws {ProblemDetails} error when the service returns a 404 status code
     * @throws {ProblemDetails} error when the service returns a 409 status code
     */
     post(body: RevokeContractSigningCommand, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<void>;
    /**
     * RevokeContractSigning
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(body: RevokeContractSigningCommand, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const RevokeRequestBuilderUriTemplate = "{+baseurl}/contracts/{contract%2Did}/signing/revoke";
/**
 * Metadata for all the requests in the request builder.
 */
export const RevokeRequestBuilderRequestsMetadata: RequestsMetadata = {
    post: {
        uriTemplate: RevokeRequestBuilderUriTemplate,
        responseBodyContentType: "application/problem+json",
        errorMappings: {
            400: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            404: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            409: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "sendNoResponseContent",
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeRevokeContractSigningCommand,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
